module.exports = __webpack_public_path__ + "static/www/img/course_python.ff4afab.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/course/course_python.jpg
// module id = 382
// module chunks = 1